import React, { useCallback } from 'react';
import { Text, DataItem } from '@cad-arc';
import { EventDetailsTabView, FieldNameEnum } from '@mark43/cad-api';
import { LinkText } from '../../../../../common/components/link-text';
import { useOpenDepartmentLink } from '../../../../../layout/use-open-department-link';
import { useBootstrapState } from '../../../../../bootstrap/bootstrap-provider';
import { useDisplayReportingEventNumbers } from '../../../../../common/hooks/use-display-reporting-event-numbers';
import { FrClickableCard } from '../../../../../common/components/fr-clickable-card';
import { useApplicationType } from '../../../../../common/hooks/use-application-type';

export function ReportingEventNumbersList(props: {
    reportingEventNumbers: EventDetailsTabView['reportingEventNumbers'];
    size?: 'sm' | 'md' | 'lg';
}): React.ReactElement {
    const { isFirstResponder } = useApplicationType();
    const openDepartmentLink = useOpenDepartmentLink();
    const { fieldDisplayNameByFieldName } = useBootstrapState();
    const renDisplayName =
        fieldDisplayNameByFieldName[FieldNameEnum.AGENCY_EVENT_REPORTING_EVENT_NUMBER.name];
    const displayReportingEventNumbers = useDisplayReportingEventNumbers(
        props.reportingEventNumbers
    );

    const openRenRmsLink = useCallback(
        (renRmsLink: string) => {
            openDepartmentLink({
                tenantStrategy: 'PREFER_RMS_TENANT',
                path: renRmsLink,
                app: 'RMS',
            });
        },
        [openDepartmentLink]
    );

    return (
        <>
            {displayReportingEventNumbers.map((reportingEventNumber) => {
                const { searchRmsLink, id, display } = reportingEventNumber;

                if (isFirstResponder) {
                    return (
                        <FrClickableCard
                            key={id}
                            handleCardClick={
                                searchRmsLink ? () => openRenRmsLink(searchRmsLink) : undefined
                            }
                        >
                            <Text fontSize={props.size}>
                                <DataItem dataKey={renDisplayName}>{display}</DataItem>
                            </Text>
                        </FrClickableCard>
                    );
                }

                return (
                    <DataItem key={id} dataKey={renDisplayName}>
                        {searchRmsLink ? (
                            <LinkText onClick={() => openRenRmsLink(searchRmsLink)}>
                                {display}
                            </LinkText>
                        ) : (
                            display
                        )}
                    </DataItem>
                );
            })}
        </>
    );
}
